const hubTitle = (stop) => {
  const name = stop?.hub_name || (stop?.hub_id != null ? `Hub ${stop.hub_id}` : 'Crossing hub');
  return stop?.location_code ? `${name} (${stop.location_code})` : name;
};

const destinationRows = (stop) => {
  if (stop?.destinations?.length) return stop.destinations;
  return (stop?.destination_hub_ids || []).map((id) => ({ id, location: String(id) }));
};

const destLabel = (dest) => {
  if (!dest?.location) return dest?.id ?? '';
  return dest.location_code ? `${dest.location} (${dest.location_code})` : dest.location;
};

/** Crossing hub, then the locations goods cross to from that hub. */
const CrossingStopsView = ({ stops, emptyLabel = 'No crossing hubs on this route.' }) => {
  if (!stops?.length) {
    return <p className="text-[11px] sm:text-xs text-gray-500">{emptyLabel}</p>;
  }

  return (
    <div className="space-y-2">
      {stops.map((stop) => {
        const destinations = destinationRows(stop);
        return (
          <div
            key={stop.hub_id}
            className="rounded-xl border border-amber-200 bg-amber-50 px-2.5 sm:px-3 py-2 min-w-0"
          >
            <p className="text-xs sm:text-sm font-semibold text-gray-800 break-words">
              {hubTitle(stop)}
            </p>
            <p className="text-[10px] sm:text-[11px] font-medium uppercase tracking-wide text-amber-800 mt-1.5 mb-1">
              Crosses to
            </p>
            {destinations.length === 0 ? (
              <p className="text-[11px] text-gray-500">No locations selected</p>
            ) : (
              <div className="flex flex-wrap gap-1">
                {destinations.map((dest) => (
                  <span
                    key={dest.id || dest.location}
                    className="inline-flex max-w-full items-center px-2 py-0.5 rounded-full bg-white border border-amber-200 text-[11px] sm:text-xs text-gray-800 break-words"
                  >
                    {destLabel(dest)}
                  </span>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CrossingStopsView;
